import api, { setToken } from './init'
import { getDecodedToken } from './token'

// Sends a POST request to /auth/sign-up on the server, with first name, last name, email & password registering the user and returning the JWT
export async function signUp(inputs) {
  try {
    const response = await api.post('/auth/signup', { ...inputs });
    const token = response.data.token;
    if (token) {
      setToken(token)
      return getDecodedToken()
    } else {
      return null
    }
  } catch (error) {
    return null;
  }

}
export async function signUpAdmin(inputs) {
  try {
    const response = await api.post('/auth/management/set-up', { ...inputs });
     
    if (response.data.code === 201) {
      return true
    } else {
      return null
    }
  } catch (error) {
    return null;
  }

}
export async function signUpExtAdmin(inputs) {
  try {
    const response = await api.post('/auth/ext-sales/set-up', { ...inputs });
    if (response.data.code === 201) {
      return true
    } else {
      return null
    }
  } catch (error) {
    return null;
  }
}

export async function generateExtSalesInvite(email) {
  try {
    const response = await api.post('/auth/ext-sales/generate-invite', { email });
    if (response.data.code === 201) {
      return { success: true, message: response.data.message }
    }
    return { success: false, message: response.data.message || 'Failed to generate invite' }
  } catch (error) {
    return { success: false, message: error.message }
  }
}

// Sends a POST request to /auth on the server, with the email & password returning the JWT
// Belonging to the user with supplied credentials
export async function signIn({ email, password, lat, long, address }) {
  const data = { email: email, password: password, lat: lat, long: long, location: address }
  return api.post('/auth/login/agent', data)
    .then(res => {
      const { token, message, success } = res.data
      if (success === true) {
        setToken(token)
        return {
          user: getDecodedToken(),
          token: token,
          success: success,
          message: message
        }
      }
      else {
        return {
          user: {},
          token: '',
          success: false,
          message: message
        }
      }
    })
    .catch(error => {
      return {
        user: {},
        token: '',
        success: false,
        message: error.message
      }
    })
}
export async function signInAdmin({ email, password }) {
  const data = { email: email, password: password }
  return api.post('/auth/login/admin', data)
    .then(res => {
      const { success, message, token } = res.data
      if (success === true) {
        setToken(token)
        return {
          token: getDecodedToken(),
          message: message,
          success: success,
          data: res.data.data
        }
      }
      else {
        return {
          token: '',
          message: message,
          success: success
        }
      }
    })
    .catch(error => {
      return {
        token: getDecodedToken(),
        message: error.message
      }
    })
}
export async function signInExtAdmin({ email, password }) {
  const data = { email: email, password: password }
  return api.post('/auth/login/ext-sales/admin', data)
    .then(res => {
      const { success, message, token } = res.data
      if (success === true) {
        setToken(token)
        return { success: true, message, ...getDecodedToken() }
      }
      return { success: false, message: message || 'Invalid credentials' }
    })
    .catch(error => ({
      success: false,
      message: error.message || 'Login failed'
    }))
}
